import React, { type ReactNode } from 'react';

import { cssMap } from '@atlaskit/css';
import { expVal } from '@atlaskit/platform-feature-experiments/exp-val';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	wrapper: {
		width: '360px',
		borderRadius: token('radius.large'),
		boxShadow: token('elevation.shadow.overflow'),
		overflow: 'hidden',
	},
	wrapperWithoutFixedWidth: {
		borderRadius: token('radius.large'),
		boxShadow: token('elevation.shadow.overflow'),
		overflow: 'hidden',
	},
});

type CardPopupWrapperProps = {
	children: ReactNode;
	constrainWidth?: boolean;
};

/**
 * Applies the popup chrome (optional size constraint, border radius, shadow) shared by
 * {@link CardLoading}, {@link CardError}, and the populated card rendered via
 * {@link UserProfileCardRelay}. Keeps popup-specific styles out of the
 * presentational {@link UserProfileCard} component.
 */
export function CardPopupWrapper({
	children,
	constrainWidth = true,
}: CardPopupWrapperProps): React.JSX.Element {
	return (
		<Box
			xcss={
				!constrainWidth && expVal('fe-fix-profile-card-hover-on-avatar-cut-off', 'isEnabled', false)
					? styles.wrapperWithoutFixedWidth
					: styles.wrapper
			}
			backgroundColor="elevation.surface.overlay"
		>
			{children}
		</Box>
	);
}
